import { OrderStatus, OrderType, PaymentsApi } from "@/api/payments";
import { QueryKey } from "@/utils";
import { useQuery } from "@tanstack/react-query";

export type PaymentsTabFilters = {
  statuses?: OrderStatus[];
  types?: OrderType[];
};

export const useGetUserPayments = ({
  userId,
  page,
  perPage,
  filters,
  sortBy,
  sortDirection,
  search,
}: {
  userId?: string;
  page: number;
  perPage: number;
  filters?: PaymentsTabFilters;
  sortBy?: string;
  sortDirection?: "asc" | "desc";
  search?: string;
}) => {
  const { data, isPending } = useQuery({
    queryKey: [
      QueryKey.USER_PURCHASES,
      userId,
      page,
      perPage,
      filters,
      sortBy,
      sortDirection,
      search,
    ],
    queryFn: () =>
      PaymentsApi.list({
        userId: userId ?? "",
        page: page + 1,
        perPage,
        statuses: filters?.statuses,
        types: filters?.types,
        sortBy,
        sortDirection,
        search,
      }),
    enabled: !!userId,
  });

  return { payments: data, isPending };
};

export const useGetPaymentDetail = (orderId: string) => {
  const { data, isPending } = useQuery({
    queryKey: [QueryKey.USER_PURCHASE_DETAIL, orderId],
    queryFn: () => PaymentsApi.getDetail({ orderId }),
    enabled: !!orderId,
  });

  return { payment: data, isPending };
};

// Keep enum re-exports here so the consumers don't pull from the deeper
// @/api/payments path explicitly.
export type { OrderStatus, OrderType };
